import { graphql } from "../gql";

export const drgReorderClaimCodesMutationDoc = graphql(`
  mutation drgReorderClaimCodes($input: DrgReorderClaimCodesInput!) {
    drgReorderClaimCodes(input: $input) {
      id
      drgStatus
      codes {
        ...DrgClaimCodeFields
      }
    }
  }
`);
